import {
  AGENT_SIDEBAR_OPEN_EVENT,
  type AgentSidebarOpenDetail,
} from "~/lib/marketplace/site-agent-sidebar";
import { SITEGLUE_LANDING_SITE_AGENT_PROJECT_ID } from "~/lib/marketplace/constants";

/** Message sent into the SiteGlue marketing chat when Book a Demo is clicked. */
export const BOOK_A_DEMO_CTA_MESSAGE = "Book a Demo";

/** Message sent into the SiteGlue marketing chat when Contact Sales is clicked. */
export const CONTACT_SALES_CTA_MESSAGE = "Contact Sales";

/**
 * Open the SiteGlue marketing chat sidebar and send a CTA message
 * (Book a Demo / Contact Sales) to the SiteGlue concierge (Victoria).
 */
export function openSiteGlueMarketingChat(message: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<AgentSidebarOpenDetail>(AGENT_SIDEBAR_OPEN_EVENT, {
      detail: {
        projectId: SITEGLUE_LANDING_SITE_AGENT_PROJECT_ID,
        allowProjectSwitch: true,
        tab: "aiChat",
        message,
      },
    }),
  );
}

/**
 * Open the SiteGlue marketing chat sidebar and send the Book a Demo CTA.
 * Used by homepage and specialty landing pages (dental, PT, legal, home services).
 */
export function openBookADemoChat(): void {
  openSiteGlueMarketingChat(BOOK_A_DEMO_CTA_MESSAGE);
}

/** Open SiteGlue marketing chat with Contact Sales. */
export function openContactSalesChat(): void {
  openSiteGlueMarketingChat(CONTACT_SALES_CTA_MESSAGE);
}

/** Open the SiteGlue marketing chat sidebar full height (Victoria, aiChat tab). */
export function openAskVictoriaChat(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<AgentSidebarOpenDetail>(AGENT_SIDEBAR_OPEN_EVENT, {
      detail: {
        projectId: SITEGLUE_LANDING_SITE_AGENT_PROJECT_ID,
        allowProjectSwitch: true,
        tab: "aiChat",
      },
    }),
  );
}
